import React, { FunctionComponent } from 'react';
import styles from './SingleOpinion.module.scss';
import { Typography, ResponsiveImage, Icon } from 'components/elements';
import { OnMobileOnly, OnTabletAndDesktopOnly } from 'utils';
import { QuotationMarkLight as QuotationMarkLightIcon } from 'assets/icons';
import { WPAcfOpinionsItem } from 'types/acf/forms';

interface OwnProps {
  opinion: WPAcfOpinionsItem;
}

type SingleOpinionProps = JSX.IntrinsicElements['div'] & OwnProps;

const SingleOpinion: FunctionComponent<SingleOpinionProps> = props => {
  const { opinion } = props;
  const { description, label, position, logo } = opinion;

  return (
    <div className={styles.company}>
      <div className={styles.container}>
        <div className={styles.content}>
          <Icon className={styles.startIcon} icon={QuotationMarkLightIcon} size={56} />
          {description && (
            <Typography className={styles.description} mobile="new_ibm_regular_16" tablet="new_ibm_regular_16" desktop="new_ibm_regular_16" as="div">
              {description}
              <OnMobileOnly>
                <Icon className={styles.endIcon} icon={QuotationMarkLightIcon} size={56} />
              </OnMobileOnly>
            </Typography>
          )}
          <div className={styles.footer}>
            {logo && (
              <ResponsiveImage
                className={styles.supplementImage}
                desktopImage={{ config: logo, imgProps: { sizes: '50vw', componentHeight: true } }}
                mobileImage={{ config: logo }}
              />
            )}
            <div>
              {label && (
                <Typography className={styles.name} mobile="ibm_bold_16" tablet="ibm_bold_16" desktop="ibm_bold_20" as="h3">
                  {label}
                </Typography>
              )}
              {position && (
                <Typography className={styles.position} mobile="new_ibm_regular_16" tablet="new_ibm_regular_16" desktop="new_ibm_regular_16" as="h4">
                  {position}
                </Typography>
              )}
            </div>
          </div>
          <OnTabletAndDesktopOnly>
            <Icon className={styles.endIcon} icon={QuotationMarkLightIcon} size={56} />
          </OnTabletAndDesktopOnly>
        </div>
      </div>
    </div>
  );
};

export default SingleOpinion;
